/* Orayta theme behaviour: reveal-on-scroll, mobile menu, product options
 * with live wall preview, and the story page's reading-progress flight. */
(function () {
  'use strict';

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('hidden') === false;
      menu.classList.toggle('flex', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var variants = data.variants;
    var optionCount = data.options.length;
    var selected = [];
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var idEl = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var addedEl = root.querySelector('[data-added]');
    var errorEl = root.querySelector('[data-cart-error]');
    var copy = JSON.parse(root.querySelector('[data-purchase-copy]').textContent);
    var submitting = false;
    idEl.disabled = false;
    var money = data.moneyFormat || '{{amount}}';

    function fmt(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amount = parts[0] + '.' + parts[1];
      if (money.indexOf('{{amount_no_decimals}}') !== -1) amount = parts[0];
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
    }

    function current() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < optionCount; j++) if (v.options[j] !== selected[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    function render() {
      var v = current();
      root.querySelectorAll('[data-opt]').forEach(function (b) {
        var i = +b.getAttribute('data-opt-index');
        var active = selected[i] === b.getAttribute('data-opt');
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
        b.disabled = submitting || !variants.some(function(candidate) { return candidate.options[i] === b.getAttribute('data-opt'); });
      });
      if (v) {
        priceEl.textContent = v.priceFmt || fmt(v.price);
        if (compareEl) { compareEl.hidden = !(v.compareAtPrice > v.price); compareEl.textContent = v.compareFmt || fmt(v.compareAtPrice || 0); }
        idEl.value = v.id;
        addBtn.disabled = submitting || !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold');
      } else {
        idEl.value = '';
        priceEl.textContent = '';
        if (compareEl) compareEl.hidden = true;
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-label-unavailable');
      }
      var kind = window.OraytaVariants.format(v);
      root.querySelector('[data-format-summary]').textContent = kind ? copy[kind] : '';
      root.querySelector('[data-format-delivery]').textContent = kind ? copy[kind === 'digital' ? 'file_delivery' : 'delivery'] : '';
      if (v) {
        var url = new URL(location.href); url.searchParams.set('variant',v.id);
        history.replaceState(null,'',url);
      }
      updateWall(v);
    }

    /* Two views of the artwork: the original and a single wall setting. */
    var mediaTrack = root.querySelector('[data-media-track]');
    var mediaButtons = root.querySelectorAll('[data-media-index]');
    if (mediaTrack) {
      var syncMediaButtons = function () {
        var index = Math.min(1, Math.max(0, Math.round(mediaTrack.scrollLeft / Math.max(1, mediaTrack.clientWidth))));
        mediaButtons.forEach(function (button) {
          button.setAttribute('aria-pressed', String(+button.getAttribute('data-media-index') === index));
        });
      };
      mediaButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          mediaTrack.scrollTo({
            left: mediaTrack.clientWidth * +button.getAttribute('data-media-index'),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
          button.focus({ preventScroll: true });
        });
      });
      mediaTrack.addEventListener('scroll', syncMediaButtons, { passive: true });
    }

    /* Wall view: scale the artwork by the selected size and show its frame. */
    var wall = root.querySelector('[data-wall]');
    var art = root.querySelector('[data-wall-art]');
    var frameBox = root.querySelector('[data-wall-frame]');
    function updateWall(v) {
      if (!wall) return;
      var sizeValue=v ? v.options.find(function(o){return /\d+\s*[x×]\s*\d+/i.test(o)}) : '';
      var dims=sizeValue && sizeValue.match(/(\d+)\s*[x×]\s*(\d+)/i);
      var landscape=Number(wall.dataset.artRatio)>1;
      var a=dims?+dims[1]:30,b=dims?+dims[2]:40;
      var originalRatio=Number(wall.dataset.artRatio)||1;
      var longSide=Math.max(a,b);
      var width=originalRatio>=1?longSide:longSide*originalRatio;
      var height=originalRatio>=1?longSide/originalRatio:longSide;
      // In the square room image, the console spans x=12.75% to 80.85%.
      // Its reference width is 180 cm; artwork and console share the same scale.
      var unit=.681/180;
      art.style.width=(width*unit*100)+'%';
      art.style.height=(height*unit*100)+'%';
      art.style.bottom='32%';
      var frameIndex = data.options.findIndex(function(name) { return /מסגרת|frame/i.test(name); });
      var frameValue = v && frameIndex >= 0 ? v.options[frameIndex] : '';
      var frameKind = /לבנה|white/i.test(frameValue) ? 'white' : /שחורה|black/i.test(frameValue) ? 'black' : /עץ|wood/i.test(frameValue) ? 'wood' : 'none';
      var surfaces = {
        white: 'linear-gradient(135deg,#fffefa 0%,#e8e5df 48%,#fdfbf7 52%,#d5d0c7 100%)',
        black: 'linear-gradient(135deg,#45423e 0%,#181715 48%,#34312c 52%,#11100f 100%)',
        wood: 'repeating-linear-gradient(94deg,#ad7e4e 0px,#c99b65 2px,#b88955 4px,#d5ad78 7px,#b78955 9px)'
      };
      frameBox.dataset.frame = frameKind;
      frameBox.style.border = 'none';
      frameBox.style.padding = frameKind === 'none' ? '0' : 'clamp(2px, .2vw, 3px)';
      frameBox.style.background = surfaces[frameKind] || 'transparent';
      frameBox.style.boxShadow = frameKind === 'none' ? '0 8px 16px -5px rgba(40,30,20,.35)' : 'inset 0 0 0 1px rgba(50,40,25,.22),0 12px 22px -5px rgba(40,30,20,.5)';
      var framedImage = frameBox.querySelector('img');
      if (framedImage) framedImage.style.boxShadow = frameKind === 'none' ? 'none' : '0 0 0 1px rgba(25,20,15,.25),0 0 4px rgba(25,20,15,.35)';
      var digital = window.OraytaVariants.format(v) === 'digital';
      wall.classList.toggle('opacity-50', !!digital);
    }
    /* initial selection = first available variant */
    var first = variants.find(function (v) { return String(v.id) === idEl.value; }) || variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (!first) { addBtn.disabled = true; return; }
    selected = first.options.slice();
    root.querySelectorAll('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var index = +b.getAttribute('data-opt-index');
        var wanted = selected.slice(); wanted[index] = b.getAttribute('data-opt');
        var chosen = window.OraytaVariants.choose(variants, selected, index, wanted[index]);
        selected = chosen ? chosen.options.slice() : wanted;
        var note = root.querySelector('[data-selection-note]');
        note.textContent = selected.some(function(o,i) { return o !== wanted[i]; }) ? note.getAttribute('data-adjusted-label') : '';
        if (errorEl) errorEl.hidden = true;
        if (addedEl) addedEl.classList.add('hidden');
        render();
      });
    });

    /* AJAX add to cart */
    var form = root.querySelector('form[data-cart-form]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v || !v.available || submitting) return;
      submitting = true;
      if (addedEl) addedEl.classList.add('hidden');
      if (errorEl) errorEl.hidden = true;
      render();
      fetch(form.action + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok || body.status >= 400) throw new Error(body.description || errorEl.getAttribute('data-default-error'));
          return body;
        });
      }).then(function () {
        if (addedEl) addedEl.classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('orayta:cart-added'));
      }).catch(function (error) {
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = error.message || errorEl.getAttribute('data-default-error'); }
      }).finally(function () { submitting = false; render(); });
    });
    render();
  }

  /* ---------- story: journey rule as reading progress ---------- */
  function initStory() {
    var rule = document.querySelector('[data-journey]');
    var target = document.querySelector('[data-story]');
    if (!rule || !target) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stops = rule.querySelectorAll('[data-stop]');
    var labels = rule.querySelectorAll('[data-stop-label]');
    var raf = 0;
    function apply(p) {
      rule.style.setProperty('--p', String(p));
      var on = [true, p > 0.5, p > 0.97];
      for (var i = 0; i < 3; i++) {
        if (stops[i]) stops[i].style.background = on[i] ? '#8a744e' : '#f2efe8';
        if (labels[i]) labels[i].style.opacity = on[i] ? '1' : '.5';
      }
    }
    if (reduced) { apply(1); return; }
    function drive() {
      var rect = target.getBoundingClientRect();
      var vh = window.innerHeight, stickyTop = 76;
      var total = Math.max(300, rect.height - (vh - stickyTop));
      apply(Math.min(1, Math.max(0, (stickyTop - rect.top) / total)));
    }
    function onScroll() { cancelAnimationFrame(raf); raf = requestAnimationFrame(drive); }
    drive();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initMenu(); initProduct(); initStory();
  });
})();

/* Keep the mobile purchase action in sync with the canonical product form. */
(function(){
 document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('[data-product]');if(!root)return;
  var main=root.querySelector('[data-add]'),price=root.querySelector('[data-price]'),bar=document.querySelector('[data-mobile-purchase]');
  if(!main||!price||!bar)return;
  var sticky=bar.querySelector('[data-sticky-add]');
  var data=JSON.parse(root.querySelector('[data-product-json]').textContent);
  var dropdowns=Array.from(root.querySelectorAll('[data-mobile-option]'));
  dropdowns.forEach(function(select){select.addEventListener('change',function(){
   var source=Array.from(root.querySelectorAll('[data-opt]')).find(function(b){return b.dataset.optIndex===select.dataset.mobileOption&&b.dataset.opt===select.value});
   if(source&&!source.disabled)source.click();else sync();
  })});
  root.classList.add('or-mobile-options-ready');
  function sync(){
   sticky.textContent=main.textContent;sticky.disabled=main.disabled;
   dropdowns.forEach(function(select){
    var sources=Array.from(root.querySelectorAll('[data-opt]')).filter(function(b){return b.dataset.optIndex===select.dataset.mobileOption});
    var active=sources.find(function(b){return b.getAttribute('aria-pressed')==='true'});
    if(active)select.value=active.dataset.opt;
    select.disabled=sources.every(function(b){return b.disabled});
    Array.from(select.options).forEach(function(option){var source=sources.find(function(b){return b.dataset.opt===option.value});option.disabled=!source||source.disabled});
   });
   bar.querySelector('[data-sticky-price]').textContent=price.textContent;
   var selected=Array.from(root.querySelectorAll('[data-opt][aria-pressed="true"]'));
   bar.querySelector('[data-sticky-options]').textContent=selected.map(function(b){return b.textContent.trim()}).join(' · ');
   var v=data.variants.find(function(v){return String(v.id)===root.querySelector('[data-variant-id]').value});
   root.querySelector('[data-delivery-card]').hidden=!!v&&v.requiresShipping===false;

  }
  sticky.addEventListener('click',function(){if(!main.disabled)main.click()});
  var observer=new MutationObserver(sync);observer.observe(price,{childList:true,subtree:true,characterData:true});observer.observe(main,{attributes:true,childList:true,subtree:true,characterData:true});
  root.querySelectorAll('[data-opt]').forEach(function(b){observer.observe(b,{attributes:true,attributeFilter:['aria-pressed','disabled']})});
  document.body.appendChild(bar);bar.hidden=false;
  // The admin preview toolbar is not part of the customer site; keep both controls usable.
  function previewOffset(){
   var frame=document.getElementById('PBarNextFrameWrapper'),offset=0;
   if(frame){var rect=frame.getBoundingClientRect();if(rect.height>0&&rect.height<=100&&rect.bottom>=window.innerHeight-2&&getComputedStyle(frame).display!=='none')offset=Math.max(0,window.innerHeight-rect.top)}
   document.body.style.setProperty('--or-preview-bottom',offset+'px');
  }
  previewOffset();window.addEventListener('resize',previewOffset,{passive:true});
  var preview=document.getElementById('PBarNextFrameWrapper');if(preview&&window.ResizeObserver)new ResizeObserver(previewOffset).observe(preview);
  window.addEventListener('load',previewOffset,{once:true});
  sync();
 });
})();
